import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppRouter } from '@/app/router'
import { Providers } from '@/app/providers'
import { detectBrowserLocale, isSupportedLocale } from '@/i18n/config'
import { initI18n } from '@/i18n'
import '@/styles/globals.css'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element #root not found in index.html')
}

/**
 * i18next is initialised BEFORE the first render.
 *
 * Rendering first and translating second produces a visible flash of
 * English for Spanish-speaking users on every cold load. For an
 * application whose Chilean half is not incidental, that is not
 * acceptable polish — it is the first impression.
 */
const initialLocale = (() => {
  const stored = localStorage.getItem('legacy.locale')
  return isSupportedLocale(stored) ? stored : detectBrowserLocale()
})()

document.documentElement.lang = initialLocale

void initI18n(initialLocale).then(() => {
  createRoot(container).render(
    <StrictMode>
      <Providers>
        <AppRouter />
      </Providers>
    </StrictMode>
  )
})
